import { render, staticRenderFns } from "./Salepoint.vue?vue&type=template&id=4bdf8a2c&scoped=true"
import script from "./Salepoint.vue?vue&type=script&lang=js"
export * from "./Salepoint.vue?vue&type=script&lang=js"
import style0 from "./Salepoint.vue?vue&type=style&index=0&id=4bdf8a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdf8a2c",
  null
  
)

export default component.exports